import React from "react";

import { Accordion } from "@/components/Atoms";

import { clsx } from "@/utils";

import styles from "./FAQSection.module.scss";

import data from "../data";

const FAQSection = () => {
  const { heading, faqs } = data.faqs;

  return (
    <div className={clsx(styles.faqSection, "container")}>
      <h2 className={styles.heading}>{heading}</h2>
      <div className={styles.faqListContainer}>
        {faqs?.map(({ question, answer }, index) => (
          <div key={index} className={styles.accordionContainer}>
            <Accordion title={question} content={answer} isWHSPage />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
